import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ApiServiceERP {
  baseURL = environment.urlServerErp;
  header = new HttpHeaders();

  constructor(private http: HttpClient) {}

  postService(infoUrl: String, json: any): Observable<any> {
    this.header = new HttpHeaders().set(
      'authorization',
      localStorage.getItem('token')
    );
    let info = this.http.post(this.baseURL + infoUrl, json, {
      headers: this.header,
    });
    return info;
  }

  postServiceDownload(infoUrl: String, json: any): Observable<any> {
   let  headers= new HttpHeaders({
      'authorization':
      localStorage.getItem('token'),
      responseType : 'blob',
      observe : 'response'
      })
    let info = this.http.post(this.baseURL + infoUrl, json, {
      headers: headers, responseType: 'blob'
    });
    return info;
  }
  

  DownloadService(infoUrl: String): Observable<any> {
    let  headers= new HttpHeaders({
      'authorization':
      localStorage.getItem('token'),
      responseType : 'blob',
      observe : 'response'
      })
    return this.http.get(this.baseURL + infoUrl, {
      headers:headers , responseType: 'blob' 
   });
  }
  
  getService(infoUrl: String): Observable<any> {
    this.header = new HttpHeaders().set(
      'authorization',
      localStorage.getItem('token')
    );
    let info = this.http.get(this.baseURL + infoUrl, { headers: this.header });
    return info;
  }

  putService(infoUrl: String): Observable<any> {
    this.header = new HttpHeaders().set(
      'authorization',
      localStorage.getItem('token')
    );
    let info = this.http.put(this.baseURL + infoUrl,{} ,{ headers: this.header });
    return info;
  }
 putServiceBody(infoUrl: String,json:any): Observable<any> {
    this.header = new HttpHeaders().set(
      'authorization',
      localStorage.getItem('token')
    );
    let info = this.http.put(this.baseURL + infoUrl,json,{ headers: this.header });
    return info;
  }
  deleteService(infoUrl: String): Observable<any> {
    this.header = new HttpHeaders().set(
      'authorization',
      localStorage.getItem('token')
    );
    let info = this.http.delete(this.baseURL + infoUrl, { headers: this.header });
    return info;
  }

  putUpdate(infoUrl: String, body :any ): Observable<any> {
    this.header = new HttpHeaders().set(
      'authorization',
      localStorage.getItem('token')
    );
    let info = this.http.put(this.baseURL + infoUrl,body ,{ headers: this.header });
    return info;
  }
}
